import React, { useState, useEffect } from 'react';
import {
    List, Datagrid, TextField, FunctionField, SimpleList, useShowController
} from 'react-admin';
import {
    useMediaQuery, makeStyles, IconButton, FormControl, InputLabel, Select, MenuItem, Paper, TableContainer, TableHead, TableRow, TableBody, withStyles, TableCell, Table, TablePagination
} from '@material-ui/core';
import { customTheme } from "./customTheme";
import ParkingSearchSelector from "./components/ParkingSearchSelector";
import CustomSearch from './components/CustomSearch';
import { useLocation } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import moment from 'moment';
import ImageGalleryDialog from './components/ImageGalleryDialog';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import ImageOutlinedIcon from '@material-ui/icons/ImageOutlined';
import TextsmsOutlinedIcon from '@material-ui/icons/TextsmsOutlined';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ScrollableTable from './components/ScrollableTable';
import config from './config.json';
import Skeleton from '@material-ui/lab/Skeleton';
import { saveTokens } from './utils/saveTokens';
import notify from './components/CustomUseNotify';
import { hideName, hideMobileNumber} from "./sharedData";

const useStyles = makeStyles({
    root: {
        width: "100%"
    },
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
    muiPopoverPaper: {
        height: "400px",
        width: "260px",
        padding: "5px 10px 5px 10px"
    },
    mainTableCell: {
        color: `${customTheme.palette.grey[900]} !important`,
        fontWeight: 500,
    },
});

const STATUS_UI = {
    "Working": {
        "backgroundColor": "#18CC69",
        "color": "#FFFFFF",
        Icon: <CheckCircleIcon style={{ fontSize: "14px", color: "#18cc69", marginRight: "5px" }} />
    },
    "Not Working": {
        "backgroundColor": "#E9C853",
        "color": "#333333",
        Icon: <CancelIcon style={{ fontSize: "14px", color: "#E9C853", marginRight: "5px" }} />
    },
    "Not Applicable": {
        "backgroundColor": "#DE575E",
        "color": "#FFFFFF",
        Icon: <RemoveCircleIcon style={{ fontSize: "14px", color: "#DE575E", marginRight: "5px" }} />
    },
    "Resolved": {
        "backgroundColor": "#18CC69",
        "color": "#FFFFFF",
        Icon: <CheckCircleIcon style={{ fontSize: "14px", color: "#18cc69", marginRight: "5px" }} />
    },
    "Not Resolved": {
        "backgroundColor": "#E9C853",
        "color": "#333333",
        Icon: <CancelIcon style={{ fontSize: "14px", color: "#E9C853", marginRight: "5px" }} />
    },
};

const ShiftDetailsSkeleton1 = props => <Skeleton variant="text" height={18} width={160} style={{ display: "inline-block", transform: "none" }} {...props} />;
// const ShiftDetailsSkeleton2 = props => <Skeleton variant="text" height={30} width={110} style={{ display: "inline-block", transform: "none" }} {...props} />;
const StyledTableCell = withStyles((theme) => ({
    root: {
        fontSize: 13,
        borderBottomColor: customTheme.palette.divider,
        padding: "15px 5px !important",
    },
    head: {
        fontWeight: 500,
        color: customTheme.palette.grey[700],
    },
    body: {
        fontWeight: 400,
        color: customTheme.palette.grey[500],
    },
}))(TableCell);

export const SiteAudits = props => {
    const classes = useStyles();
    const location = useLocation();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    // const { permissions } = usePermissions();
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});

    const [displayModal, setDisplayModal] = useState(false);
    const [auditData, setAuditData] = useState("")

    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));


    const [search, setSearch] = useState(prevSearch.inputSearch)
    let searchTypeState = ["Name", "Mobile"]
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Name");
    const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
	const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");

	const renderTime = time => {
		const secondsFormat = showTimeTillSeconds ? ":ss" : "";
        if(use24HourFormat) return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY HH:mm${secondsFormat}`)
        return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY hh:mm${secondsFormat} A`)
	};


    const filter = { search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined };

    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    return <div className={classes.list}>
        <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
            {showFilter &&
                <ParkingSearchSelector
                    value={currentParking}
                    onChange={onParkingChange}
                    clearable={true}
                    pathName={location.pathname}
                />
            }

            {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                    <InputLabel>Zone Name</InputLabel>
                    <Select
                        value={currentParking.allZones ? "All" : currentParking.id}
                        onChange={onZoneChange}
                        label="Zone Name"
                        variant="outlined"
                    >
                        <MenuItem value="All">All</MenuItem>
                        {finalZones.map((zone, index) => (
                            <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            }
        </div>
        <div className='customStyleForDataSearchDiv'>
            <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
        </div>
        <List
            style={{ marginTop: 20 }}
            {...props}
            title="Site Audits"
            bulkActionButtons={false}
            exporter={false}
            filter={filter}
            empty={false}
            sort={{ field: 'timestamp', order: 'DESC' }}
            actions={false}
            pagination={<CustomPagination />}
        >
            {
                isSmallDevice ?
                    <SimpleList
                        primaryText={record => hideName(record.name)}
                        secondaryText={record => (<div onClick={() => {
                            setDisplayModal(true)
                            setAuditData(JSON.parse(record.data))
                        }}>
                            {record.mobile && <div><span style={{ color: "#5a5a5a" }}>Mobile No: </span>{hideMobileNumber(record.mobile)}</div>}
                            {record.timestamp && <div><span style={{ color: "#5a5a5a" }}>Created On: </span>{renderTime(record["timestamp"])}</div>}
                            {record.parking_name && <div><span style={{ color: "#5a5a5a" }}>Parking Name: </span>{record.parking_name}</div>}
                        </div>)}
                        onContextMenu={event => event.preventDefault()}
                        linkType={false}
                        rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                    />
                    :
                    <Datagrid component={ScrollableTable} expand={SiteMaintenance}>
                        {/* <TextField source="name" label="Auditor Name" /> */}
                        <FunctionField source='name' label="Auditor Name" render={record => record && <p style={{ color: "#334d6e", cursor: "pointer" }}
                            onClick={() => {
                                setDisplayModal(true)
                                setAuditData(JSON.parse(record.data))
                            }}>{hideName(record.name)}</p>} />
                        <FunctionField source="mobile" label="Mobile" render={record => record && record["mobile"] ? hideMobileNumber(record.mobile) : '-'} />
                        {/* <FunctionField source="data" label="Audit Data" render={record => <CustomSiteDataReport record={record} setAuditData={(val) => setAuditData(val)} setDisplayModal={setDisplayModal} />} /> */}
                        <FunctionField source="timestamp" label="Timestamp" render={record => record && renderTime(record["timestamp"])} />
                        <TextField source='parking_name' label="Parking Name" />

                    </Datagrid>
            }
        </List>
        <CustomModal displayModal={displayModal} setDisplayModal={setDisplayModal} auditData={auditData} modelType={"Audit"} />
    </div>
};

const CustomModal = ({ displayModal, setDisplayModal, auditData, modelType }) => {
    let checkList = auditData
    const [openSubComponent, setOpenSubComponent] = useState({ component: null, subComponent: null });
    const toggleSubComponent = (component, subComponent) => {
        if (component === openSubComponent.component && subComponent === openSubComponent.subComponent) {
            setOpenSubComponent({ component: null, subComponent: null });
        } else {
            setOpenSubComponent({ component, subComponent });
        }
    };

    const StatusSelector = ({ currentStatus }) => {
        const status = {
            "Working": "Working",
            "Not Working": "Not Working",
            "Not Applicable": "Not Applicable",
            "Resolved": "Resolved",
            "Not Resolved": "Not Resolved"
        }
        return <p style={{ fontSize: 14 }}>Status: <strong>{status[currentStatus]}</strong></p>
    };

    const Comments = ({ comment }) => {
        return <p style={{ fontSize: 14 }}>Comment: <strong>{comment}</strong></p>
    };
    return (
        <div>
            <div className={`CustomModal ${displayModal ? "Show" : ""}`}>
                <div className='siteAuditsScroll' style={{ overflow: "auto", overflowX: "hidden", height: "calc(100vh - 50px)", margin: "0px 0px 0px 0px", padding: "0px 0px 20px 20px", }}>
                    <IconButton
                        onClick={() => setDisplayModal(!displayModal)}
                    >
                        <ArrowBackIcon />
                    </IconButton>
                    {Object.keys(checkList).map(component => {
                        return <div key={component}>
                            <p style={{ fontWeight: "bold", fontSize: 16, color: "#272727" }}>{component}</p>
                            {Object.keys(checkList[component].components).map(subComponent => {
                                const open = component === openSubComponent.component && subComponent === openSubComponent.subComponent;
                                return <div key={subComponent} style={{ border: "1px solid #ccc", borderRadius: 7, padding: "0px 10px", margin: "8px 0px", width: "280px", cursor: "pointer" }}>
                                    <div onClick={() => toggleSubComponent(component, subComponent)}>
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                {checkList[component].components[subComponent].status && modelType === "Audit" ? STATUS_UI[checkList[component].components[subComponent].status].Icon : checkList[component].components[subComponent].resolutionStatus && modelType === "Resolution" ? STATUS_UI[checkList[component].components[subComponent].resolutionStatus].Icon : null}
                                                <p style={{ fontWeight: "bold", fontSize: 12, lineHeight: "10px", color: "#272727" }}>{subComponent}</p>
                                            </div>


                                            {
                                                modelType === "Audit" &&
                                                <div style={{ display: "flex", alignItems: "center" }} >
                                                    {checkList[component].components[subComponent].hasOwnProperty("images") && <ImageOutlinedIcon style={{ color: "#c3c3c375", fontSize: 18, marginRight: 5 }} />}
                                                    {checkList[component].components[subComponent].comment && <TextsmsOutlinedIcon style={{ color: "#c3c3c375", fontSize: 18 }} />}
                                                    {open ? <KeyboardArrowDownIcon style={{ color: "#272727", fontSize: 18 }} /> : <ChevronRightIcon style={{ color: "#666", fontSize: 18 }} />}
                                                </div>
                                            }

                                            {
                                                modelType === "Resolution" &&
                                                <div style={{ display: "flex", alignItems: "center" }} >
                                                    {checkList[component].components[subComponent].hasOwnProperty("resolutionImages") && <ImageOutlinedIcon style={{ color: "#c3c3c375", fontSize: 18, marginRight: 5 }} />}
                                                    {checkList[component].components[subComponent].resolutionComment && <TextsmsOutlinedIcon style={{ color: "#c3c3c375", fontSize: 18 }} />}
                                                    {open ? <KeyboardArrowDownIcon style={{ color: "#272727", fontSize: 18 }} /> : <ChevronRightIcon style={{ color: "#666", fontSize: 18 }} />}
                                                </div>
                                            }
                                        </div>
                                    </div>

                                    {open && <div>
                                        {
                                            modelType === "Audit" ?
                                                <StatusSelector
                                                    currentStatus={checkList[component].components[subComponent].status}
                                                />
                                                :
                                                <StatusSelector
                                                    currentStatus={checkList[component].components[subComponent].resolutionStatus}
                                                />
                                        }

                                    </div>}
                                    {
                                        open &&
                                        <div>
                                            {
                                                modelType === 'Audit' ?
                                                    <Comments
                                                        comment={checkList[component].components[subComponent].hasOwnProperty("comment") ? checkList[component].components[subComponent].comment : "No Comments."}
                                                    />
                                                    :
                                                    <Comments
                                                        comment={checkList[component].components[subComponent].hasOwnProperty("resolutionComment") ? checkList[component].components[subComponent].resolutionComment : "No Comments."}
                                                    />
                                            }
                                        </div>
                                    }
                                    {
                                        open && checkList[component].components[subComponent].hasOwnProperty("images") && modelType === 'Audit' &&
                                        <div>
                                            <p style={{ fontSize: 14 }}>View Images:</p>
                                            <div style={{ marginBottom: 10 }}>

                                                <ImageGalleryDialog style={{ textAlign: "none" }} thumbnail={true} thumbnailStyle={{ minWidth: "80px", width: "85px", borderRadius: 5, height: "70px", }} record={checkList[component].components[subComponent].images} getImages={img => [...img]}>
                                                </ImageGalleryDialog>
                                            </div>
                                        </div>

                                    }
                                    {
                                        open && checkList[component].components[subComponent].hasOwnProperty("resolutionImages") && modelType === 'Resolution' &&
                                        <div>
                                            <p style={{ fontSize: 14 }}>View Images:</p>
                                            <div style={{ marginBottom: 10 }}>

                                                <ImageGalleryDialog style={{ textAlign: "none" }} thumbnail={true} thumbnailStyle={{ minWidth: "80px", width: "85px", borderRadius: 5, height: "70px", }} record={checkList[component].components[subComponent].resolutionImages} getImages={img => [...img]}>
                                                </ImageGalleryDialog>
                                            </div>
                                        </div>

                                    }
                                </div>
                            })}
                        </div>
                    })}
                </div>
            </div>
            <div
                className={`CustomOverlay ${displayModal ? "Show" : ""}`}
                onClick={() => setDisplayModal(!displayModal)}
            />
        </div>
    )
}


function SiteMaintenance(props) {
    const { record } = useShowController(props);
    //const notify = useNotify();
    const classes = useStyles();

    // const [details, setDetails] = useState(null);
    const [auditMaintenance, setAuditMaintenance] = useState(null);
    const [noSiteAudits, setNoSiteAudits] = useState(false)

    const [displayModal, setDisplayModal] = useState(false);
    const [auditData, setAuditData] = useState("")

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(25);
    // const [order, setOrder] = React.useState("desc");
    // const [orderBy, setOrderBy] = React.useState("Exit Time");

    let visibleRows = null;
    if (auditMaintenance)
        visibleRows = auditMaintenance.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // const handleRequestSort = (property) => {
    //     const isAsc = orderBy === property && order === 'asc';
    //     let tempOrder = isAsc ? 'desc' : 'asc';
    //     setOrder(tempOrder);
    //     setOrderBy(property);

    //     const tempVehicles = auditMaintenance;
    //     tempVehicles.sort(createSortable(tempOrder, property));
    //     setAllVehicles(tempVehicles);
    // };

    useEffect(() => {
        if (record) {
            fetch(`${config.HOST_NAME}/crm/v3/siteMaintenance/${record.id}`, {
                method: 'GET',
                headers: {

                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                }
            })
                .then(response => {
                    saveTokens(response)
                    return response.json()
                })
                .then(json => {
                    if (json.success) {
                        setAuditMaintenance(json.data);
                    } else {
                        notify(json.message, "warning");
                        setNoSiteAudits(true)
                    }
                }).catch((e) => {
                    console.log(e)
                    notify('Could not fetch audit maintenance', 'warning');
                });
        }
    }, [record]); // eslint-disable-line react-hooks/exhaustive-deps

    if (!record) return null;
    return (
        <div>
            <Paper style={{ width: "100%", mb: 2, boxShadow: "none", padding: noSiteAudits ? "0 10px" : "0 1px", border: "1px solid #bfbfbf", borderRadius: 10, marginTop: 20 }}>
                {
                    noSiteAudits ?
                        <p>No Site Maintenance Found</p>
                        :
                        <>
                            <TableContainer component={Paper} style={{ boxShadow: "none", padding: 0, maxHeight: 300 }}>
                                <Table stickyHeader size="small" style={{ padding: 0 }} className="tableRow-padding-3">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Auditor Name</StyledTableCell>
                                            <StyledTableCell>Mobile</StyledTableCell>
                                            <StyledTableCell>Timestamp</StyledTableCell>
                                            <StyledTableCell>Parking Name</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {visibleRows ?
                                            visibleRows.map((row, index) => (<TableRow key={row["id"]}>
                                                <StyledTableCell component="th" scope="row" className={classes.mainTableCell}
                                                    onClick={() => {
                                                        setDisplayModal(true)
                                                        setAuditData(JSON.parse(row.data))
                                                    }}
                                                >{row["name"]}</StyledTableCell>
                                                <StyledTableCell>{row.mobile}</StyledTableCell>
                                                <StyledTableCell>{moment(row["timestamp"], "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY hh:mm:ss A")}</StyledTableCell>
                                                <StyledTableCell>{row.parking_name}</StyledTableCell>
                                            </TableRow>))
                                            :
                                            [1, 2, 3].map((row) => (<TableRow key={row}>
                                                <StyledTableCell component="th" scope="row" className={classes.mainTableCell}><ShiftDetailsSkeleton1 width={100} /></StyledTableCell>
                                                <StyledTableCell><ShiftDetailsSkeleton1 width={100} /></StyledTableCell>
                                                <StyledTableCell><ShiftDetailsSkeleton1 width={100} /></StyledTableCell>
                                                <StyledTableCell><ShiftDetailsSkeleton1 width={100} /></StyledTableCell>
                                            </TableRow>))
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <TablePagination
                                rowsPerPageOptions={[25, 50, 100]}
                                count={auditMaintenance ? auditMaintenance.length : 0}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                            />
                        </>
                }
            </Paper>
            <CustomModal displayModal={displayModal} setDisplayModal={setDisplayModal} auditData={auditData} modelType={"Resolution"} />
        </div>
    );
}